// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1wAa5","icon":"SortAdornment_icon__W4S9U","up":"SortAdornment_up__2f4T5","down":"SortAdornment_down__27F77","active":"SortAdornment_active__3hcbs"};